import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {H4, Body, Label} from "@irati/ui/src/Typography"

export const Wrapper = styled.div`
  .recharts-label {
    font-size: 10px;
    font-weight: 400;
    font-family: ${({theme}) => theme.font.default};
  }
  .recharts-cartesian-grid-horizontal line:last-child {
    display: none;
  }
`

export const HighlightedCard = styled(Card)`
  ${({theme}) => css`
    background-color: ${theme.colors.utility.highlight};
    ${Body}, ${Label} {
      color: ${theme.colors.primary2};
    }
  `}
`

export const HightlightedCardH4 = styled(H4)`
  color: ${({theme}) => theme.colors.primary2};
`
